import { styled, Typography } from '@mui/material';

export const StyledTitle = styled(Typography)(({ theme }) => ({
    fontSize: '1.25rem',
    fontWeight: 600,
    lineHeight: '160%',
    marginBottom: '1rem',
    color: theme.palette.secondary.main
}));
